var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValidateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2C9.72363 2 9.5 2.22362 9.5 2.5C9.5 2.77638 9.725 3 10 3C10.5513 3 11 3.44812 11 4V14C11 14.5519 10.5513 15 10 15H2C1.44875 15 1 14.5519 1 14V4C1 3.44812 1.44875 3 2 3C2.27638 3 2.5 2.77638 2.5 2.5C2.5 2.22362 2.27625 2 2 2C0.896875 2 0 2.8975 0 4V14C0 15.1025 0.896875 16 2 16H10C11.1031 16 12 15.1025 12 14V4C12 2.8975 11.1031 2 10 2ZM3.5 4H8.5C8.775 4 9 3.775 9 3.5C9 3.225 8.775 3 8.5 3H7.7225C7.89375 2.70469 8 2.36625 8 2C8 0.895313 7.10469 0 6 0C4.89531 0 4 0.895313 4 2C4 2.36625 4.10559 2.70469 4.27741 3H3.5C3.225 3 3 3.225 3 3.5C3 3.775 3.225 4 3.5 4ZM6 1C6.55125 1 7 1.44875 7 2C7 2.55125 6.55125 3 6 3C5.44875 3 5 2.55125 5 2C5 1.44875 5.45 1 6 1ZM2.64656 9.35312L4.64656 11.3531C4.74375 11.45 4.87187 11.5 5 11.5C5.12813 11.5 5.25588 11.4512 5.35344 11.3535L9.35344 7.3535C9.54875 7.15819 9.54875 6.84163 9.35344 6.64663C9.15812 6.45162 8.84156 6.45131 8.64656 6.64663L5 10.2937L3.35313 8.64688C3.15781 8.45156 2.84125 8.45156 2.64625 8.64688C2.45125 8.84219 2.45125 9.15937 2.64656 9.35312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidateIcon);
export default __webpack_public_path__ + "static/media/ValidateIcon.9661c5a38e7549988378c1e7d2cd2a31.svg";
export { ForwardRef as ReactComponent };